import React from "react";
import "../../City/CityInfo/style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//import Form from "react-bootstrap/Form";
//import Button from "components/Button/Button";
//import CoverPhoto from "pages/City/CityInfo/CoverPhoto";
//import SocialMedia from "pages/City/CityInfo/SocialMedia";
//import CityAdmin from "pages/City/CityInfo/CityAdmin";
//import PlaceholderImage from "Assets/present-img.png";
//import { apiUrl, myHeaders_Autorized, HeaderConfig,events_list_api, channel_list_api, myHeaders_With_Cache_Control } from "Api/Api";
import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// , myHeaders_With_Cache_Control, myHeaders_Authorized
import axios from 'axios';
import { Link } from "react-router-dom";
import { local_routes } from 'utils/Routes';
//import { get_current_unix_stamp } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
//import Select from 'react-select';
//import MultipleImagesUpload from 'components/MultipleImagesUpload/MultipleImagesUpload';

import ListGroup from 'react-bootstrap/ListGroup'

//import PkCommentBox from "components/Comments/Comments";

class PechaKuchaInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comment_pks: [],
            loading: true,
            message: null
        };
        
    }

    componentDidMount = async function () {
        await this.getFromApi();
    }

    getFromApi = async () => {
        this.setState({ loading: true, message: null });
        let new_state = {...this.state};
        console.log("PechaKuchaInfo getFromApi new_state 1",JSON.stringify(new_state,null,2));
        let comments_response = null;
        try {
            comments_response = await axios.get(`${apiUrl}comments?status_code=3`,myHeaders_Auth_With_Cache_Control)
        } catch (err) {
            console.error("Something wrong!",err);
            this.setState({
                loading:false,
                message: 'Unknown Error'
            });
            return;
        }
        
        if (!comments_response.data || !comments_response.data.entities || comments_response.data.entities.length === 0) {
            this.setState({
                loading: false,
                message: 'No unapproved comments!'
            });
            return;
        }
        
        // get presentation info per unapproved comment
        let api_promises = [];
        let unapproved_comments_presentation_map = {};
        //let attributes_array = ['entity_uuid','status_code','friendly_url','entity_name'];
        
        let params = {
          attributes: ['entity_uuid','status_code','friendly_url','entity_name'],
          filter_obj: {
            status_code: {
              eq: 1
            }
          }
        }
        
        for (let comment_obj of comments_response.data.entities) {
            //api_promises.push(axios.get(`${apiUrl}comments/${comment_obj.entity_uuid}/presentations?attributes_array=${encodeURIComponent(JSON.stringify(attributes_array))}`));
            api_promises.push(axios.get(`${apiUrl}comments/${comment_obj.entity_uuid}/presentations`, { params, ...myHeaders_Auth_With_Cache_Control}));
        }
        let presentations_responses = await Promise.all(api_promises);
        //console.log("YO1",presentations_responses);
        for (let presentation_response of presentations_responses) {
            if (presentation_response.data.length > 0) {
                if (unapproved_comments_presentation_map[presentation_response.data[0].entity_uuid]) {
                    unapproved_comments_presentation_map[presentation_response.data[0].entity_uuid].unapproved_comment_count++;
                } else {
                    unapproved_comments_presentation_map[presentation_response.data[0].entity_uuid] = presentation_response.data[0];
                    unapproved_comments_presentation_map[presentation_response.data[0].entity_uuid].unapproved_comment_count = 1;
                }
            }
        }
        //console.log("YO2",Object.values(unapproved_comments_presentation_map));
        
        this.setState({
            loading: false,
            comment_pks: Object.values(unapproved_comments_presentation_map)
        })
        
    }



    render() {
            
        if (this.state.loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            );
        }

        return (
            <div className="city-info">
                <div className="container pad-bot30">
                <Row className="pad-top50 pad-bot30 editCity">
                    <Col lg={6} md={6} sm={6} className="pad0" >
                        <h1>PechaKucha Comments</h1>
                    </Col>
                    <Col lg={6} md={6} sm={6} className="pad0" >
                        {this.state.message}
                    </Col>
                </Row>
                <Row style={{ paddingBottom: '20px' }}>
                    <h4>Presentations with Unapproved Comments</h4>
                </Row>
                <Row>
                    <ListGroup>
                    {
                        this.state.comment_pks.map( element => {
                            return (
                                <ListGroup.Item key={element.entity_uuid}>
                                    <Link target="_blank" to={local_routes.presentations+'/'+element.friendly_url}>{element.entity_name}</Link>
                                </ListGroup.Item>
                            );
                        })
                    }
                    </ListGroup>
                </Row>
                </div>
            </div>
        );
        

    }
}

export default PechaKuchaInfo;
